import { useMoney } from "../../../../../currency/useMoney"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

import { findExampleRow, hasPriceChange, PreviewRow } from "./adjustPricesLib"

type PreviewPanelSubtitleProps = Readonly<{
    rows: ReadonlyArray<PreviewRow>
    hasScope: boolean
}>

export function PreviewPanelSubtitle({ rows, hasScope }: PreviewPanelSubtitleProps) {
    const moneyFactory = useMoney({})

    if (!hasScope) {
        return (
            <LocalizedStrict id="adjust-price-list-scope-subtitle-empty">
                <span>Choose at least one product group.</span>
            </LocalizedStrict>
        )
    }

    if (rows.length === 0) {
        return (
            <LocalizedStrict id="adjust-price-list-preview-empty">
                <span>Enter a percentage and pick at least one product group to see the new prices.</span>
            </LocalizedStrict>
        )
    }

    const example = findExampleRow(rows)
    const changedCount = rows.filter(hasPriceChange).length
    const from = moneyFactory.format(example.current)
    const to = moneyFactory.format(example.next)

    return (
        <LocalizedStrict id="adjust-price-list-preview-summary" vars={{ count: changedCount, from, to }}>
            <span>
                {changedCount} items changed · e.g. {from} → {to}
            </span>
        </LocalizedStrict>
    )
}
